import { getFontColorForBackgroundContrast } from "QuorumGrassroots/styled-components/helperFunctions"
import React from "react"

interface RequiredIconProps {
    color?: string
}

export const RequiredIcon = ({ color }: RequiredIconProps) => {
    const primaryColor = window.organization_design.primary_color
    const fill = getFontColorForBackgroundContrast(primaryColor)

    return (
        <svg
            width="16"
            height="13"
            viewBox="0 0 16 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Required field indicator"
            role="img"
        >
            <path
                d="M1.39062 0.640625L6.6875 4.76562L10.4844 0.96875C11.0703 0.382812 12.0312 0.382812 12.6172 0.96875L13.5312 1.88281C13.6016 1.95312 13.6719 2.04688 13.7188 2.11719C14.1172 2.70312 14.0469 3.5 13.5312 4.01562L10.0859 7.4375L15.2656 11.5156C15.5234 11.7031 15.5703 12.0547 15.3594 12.2891C15.1719 12.5469 14.8203 12.5938 14.5859 12.3828L0.710938 1.50781C0.453125 1.32031 0.40625 0.96875 0.617188 0.734375C0.804688 0.476562 1.15625 0.429688 1.39062 0.640625ZM7.57812 5.46875L9.19531 6.75781L10.9766 4.97656L9.52344 3.52344L7.57812 5.46875ZM4.15625 8.89062C4.13281 8.89062 4.13281 8.91406 4.10938 8.9375C4.01562 9.03125 3.96875 9.14844 3.92188 9.28906L3.75781 9.82812L3.38281 11.1172L4.67188 10.7422L5.21094 10.5781C5.35156 10.5312 5.49219 10.4609 5.60938 10.3438L7.60156 8.35156L8.49219 9.05469L6.40625 11.1406C6.38281 11.1641 6.33594 11.1875 6.3125 11.2344C6.07812 11.4219 5.82031 11.5625 5.53906 11.6562L3.71094 12.1953L2.70312 12.4766C2.51562 12.5469 2.30469 12.5 2.16406 12.3359C2 12.1953 1.95312 11.9844 2.02344 11.7969L2.30469 10.7891L2.84375 8.96094C2.9375 8.63281 3.125 8.32812 3.35938 8.09375L5.07031 6.38281L5.96094 7.08594L4.15625 8.89062Z"
                fill={color ?? fill}
            />
        </svg>
    )
}
